import axios from "axios";
import { getToken } from "./getToken";

const url = `${process.env.AGW_EMPLEO_SERVICES_API_URL}`;
const apikeyServices = process.env.AGW_EMPLEO_SERVICES_API_KEY;

 export const getEnterpriseMentorshipValidator = async (Nit: string) => {
    const token = await getToken();
    const headers = {
        Authorization: token.data.data.id_token,
        apikey: apikeyServices,
    };
    return axios.get(`${url}comfama/form-employment/api/v1/mentoring/business/${Nit}`, { headers });
}